import React, { useState, useEffect } from 'react';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../../firebase/config';
import { FileText, Printer } from 'lucide-react';

// 🌏 해외 발주측 — 받은 인보이스(외주명세서) 목록 (영문, 읽기 전용 + 브라우저 인쇄)
function GlobalInvoices({ user }) {
    const myUid = user?.companyId || user?.uid;
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        (async () => {
            if (!myUid) return;
            try {
                const snap = await getDocs(query(collection(db, 'outsourceStatements'), where('toUserId', '==', myUid)));
                const list = snap.docs.map(d => ({ id: d.id, ...d.data() }));
                list.sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));
                setRows(list);
            } catch (e) { console.error('인보이스 로드 실패:', e); }
            finally { setLoading(false); }
        })();
    }, [myUid]);

    const fmt = (v) => v?.toDate ? v.toDate().toLocaleDateString('en-US') : (typeof v === 'string' ? v : '-');
    const money = (n, cur) => `${cur || 'KRW'} ${Number(n || 0).toLocaleString('en-US')}`;

    return (
        <div style={{ maxWidth: 860, margin: '0 auto', padding: 20 }}>
            <h1 style={{ fontSize: 22, fontWeight: 800, color: '#1E2230' }}><FileText size={20} style={{ verticalAlign: -2 }} /> Invoices</h1>
            <p style={{ fontSize: 13.5, color: '#5A6072', margin: '4px 0 18px' }}>
                Monthly statements issued by your Korean lab, covering confirmed cases. Payment details (bank / Wise / PayPal) are on each invoice — pay directly to the lab.
            </p>
            {loading ? <div style={{ color: '#5A6072', padding: 30 }}>Loading…</div> : rows.length === 0 ? (
                <div style={{ textAlign: 'center', color: '#94A3B8', padding: '50px 0', background: '#fff', border: '1px solid #E4E6EE', borderRadius: 12 }}>
                    No invoices yet.
                </div>
            ) : (
                <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                    {rows.map(r => (
                        <div key={r.id} style={{ background: '#fff', border: '1px solid #E4E6EE', borderRadius: 12, padding: '16px 20px' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
                            <div>
                                <div style={{ fontWeight: 800, fontFamily: 'ui-monospace, monospace' }}>{r.statementNumber || r.id.slice(0, 8)}</div>
                                <div style={{ fontSize: 12.5, color: '#5A6072', marginTop: 2 }}>
                                    From {r.fromUserName || 'Lab'} · {fmt(r.periodStart)} – {fmt(r.periodEnd)} · {(r.items || []).length} items
                                </div>
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
                                <div style={{ textAlign: 'right' }}>
                                    <div style={{ fontWeight: 800, fontSize: 16 }}>{money(r.totalAmount || r.finalAmount, r.currency)}</div>
                                    <div style={{ fontSize: 11.5, fontWeight: 700, color: r.settlementStatus === 'completed' ? '#0B6E5D' : '#B45309' }}>
                                        {r.settlementStatus === 'completed' ? 'PAID' : 'AWAITING PAYMENT'}
                                    </div>
                                </div>
                                <button onClick={() => window.print()} title="Print"
                                    style={{ border: '1px solid #E4E6EE', background: '#fff', borderRadius: 8, padding: 8, cursor: 'pointer', color: '#5A6072' }}>
                                    <Printer size={15} />
                                </button>
                            </div>
                        </div>
                        {r.paymentInfo && (
                            <div style={{ marginTop: 12, paddingTop: 12, borderTop: '1px dashed #E4E6EE', fontSize: 12.5, color: '#475569', lineHeight: 1.7 }}>
                                <b style={{ color: '#1E2230' }}>Payment instructions</b><br />
                                {r.paymentInfo.bankName && <>Bank: {r.paymentInfo.bankName}{r.paymentInfo.bic ? ` · SWIFT ${r.paymentInfo.bic}` : ''}<br /></>}
                                {r.paymentInfo.accountNo && <>Account: {r.paymentInfo.accountNo}{r.paymentInfo.beneficiary ? ` · Beneficiary: ${r.paymentInfo.beneficiary}` : ''}<br /></>}
                                <span style={{ display: 'inline-flex', gap: 8, marginTop: 4 }}>
                                    {r.paymentInfo.wiseUrl && <a href={r.paymentInfo.wiseUrl} target="_blank" rel="noreferrer" style={{ color: '#4F52C7', fontWeight: 700 }}>Pay with Wise →</a>}
                                    {r.paymentInfo.paypalMe && <a href={r.paymentInfo.paypalMe} target="_blank" rel="noreferrer" style={{ color: '#4F52C7', fontWeight: 700 }}>PayPal →</a>}
                                </span>
                            </div>
                        )}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}

export default GlobalInvoices;
